import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
type CreateCouponDTO = {
    name: string,
    code: string,
    discount:number,
};

type CouponResponse  = CreateCouponDTO & ApiError;

export const CreateCoupon = (data: CreateCouponDTO): Promise<CouponResponse> => {
    return axios.post("/coupon/create", data)
        .then(response => response.data as CouponResponse);
};